export default __webpack_public_path__ + "static/media/echo-ult.fd2a5c35.mp3";